import {OverlayContainer} from "../../../misc/ImageViewer";
import Settings from "../../../settings/Settings";
import React, {useEffect, useState} from "react";
import SchemaEditContainer from "../SchemaEditContainer";
import {SqlQuery} from "../BackTableFieldViewTable";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {schemas} from "../../../../config";
import {PHP_TYPE_MAP, PhpType, setBackTableJoin, setBackTableUpdateField} from "../../../../features/schemaManageSlice";


type PropsI = {
    closeEditing: () => void,
    fieldKey: string,
    type: PhpType,
    addNew?: boolean
};
export default function EditUpd({closeEditing, type, fieldKey, addNew = false}: PropsI) {

    const tableName = useAppSelector(state => state.schemaManage.back.selectedTable) as string;
    const table = useAppSelector(state => state.schemaManage.back.tables[tableName]);
    const ethereal = useAppSelector(state => state.schemaManage.back.etherealTables[tableName])!;

    const [newValue, setNewValue] = useState(type)
    const [name, setName] = useState(fieldKey)

    const dispatch = useAppDispatch();

    const fields = Object.keys(table.fieldsList);
    const updatableFields = Object.keys(ethereal.updatableFields);
    const availableFields = fields.filter(f => !updatableFields.includes(f));

    useEffect(() => {
        if (addNew && availableFields.length > 0)
            setName(availableFields[0])
    }, []);

    if (addNew && availableFields.length === 0)
        return <OverlayContainer $isVisible>
            <SchemaEditContainer>
                <div>ВСІ ПОЛЯ ВЖЕ ОБРАНІ</div>
                <div>
                    <button className="close btn-cmn" onClick={closeEditing}>
                        ❌
                    </button>
                </div>
            </SchemaEditContainer></OverlayContainer>

    return <OverlayContainer $isVisible>
        <SchemaEditContainer>
            <div>{addNew ? "Створити" :"Редагувати"} оновлюване поле {name}</div>
            {addNew && <div>
                <select name="keys" id="keys" value={name} onChange={e => setName(e.target.value)}>
                    {availableFields.map(f => <option value={f} key={f}>{f}</option>)}
                </select>
            </div>}
            <div>Тип:</div>
            <select name="type" id="type" value={newValue}
                    onChange={e => setNewValue( (e.target.value as PhpType))}>
                {Object.entries(PHP_TYPE_MAP).map(([key, value]) => <option value={key}
                                                                            key={key}>{value.desc}</option>)}
            </select>
            {!addNew && <div className="delete-join">
                <button className={'btn-cmn'} onClick={() => {
                    dispatch(setBackTableUpdateField({
                        table: tableName,
                        fieldKey: fieldKey,
                        value: undefined
                    }))
                    closeEditing()
                }}>Видалити це поле
                </button>
            </div>}
            <div className={'controls'}>
                <button className={'save btn-cmn'} onClick={() => {
                    if (addNew && ethereal && ethereal.updatableFields[name]) {
                        alert("Поле з таким ключем вже є! Змініть ключ")
                        return
                    }
                    dispatch(setBackTableUpdateField({
                        table: tableName,
                        fieldKey: name,
                        value: newValue
                    }))
                    closeEditing()
                }}>
                    Зберегти
                </button>
                <button className="close btn-cmn" onClick={closeEditing}>
                    ❌
                </button>
            </div>
        </SchemaEditContainer>
    </OverlayContainer>

}

